import styled from 'styled-components';
import { customMedia, hexa, media } from 'styles/utils';
import Button from 'components/Button';

export const ModalMainWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Overlay = styled.div`
  z-index: ${props =>
    props.toFront ? '1000000' : props.allCustom ? '10000' : '1000000'};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${props =>
    props.visible
      ? `${hexa(props.theme.color.wfGrey900, 0.6)}`
      : 'transparent'};
  pointer-events: ${props => (props.visible ? 'auto' : 'none')};
  transition: background-color 300ms linear;
  overflow-y: auto;
`;

export const Main = styled.article`
  margin: ${props => props.theme.spacing.xlarge} auto 0;
  padding: ${props =>
    props.size === 'large' || props.noPadding
      ? '0'
      : `${props.theme.spacing.large} ${props.theme.spacing.default}`};
  background: ${props => props.theme.color.wfWhite};
  box-shadow: ${props => `0 2px 12px ${hexa(props.theme.color.wfBlack, 0.3)}`};
  opacity: ${props => (props.fadedIn ? '1' : '0')};
  transition: opacity 450ms ease-in-out, transform 450ms ease-in-out;
  position: relative;
  width: ${props =>
    props.availableRatio
      ? `calc((${props.theme.layout.ratio[0]} * (100vh - (2 * ${props.theme.spacing.xlarge}))) / ${props.theme.layout.ratio[1]})`
      : props.small
      ? '40%'
      : '70%'};
  min-width: 26rem;
  max-width: ${props =>
    props.availableRatio
      ? '92vw'
      : props.size === 'large'
      ? '1000px'
      : '740px'};

  ${media.medium`
    padding: ${props =>
      props.size === 'large' || props.noPadding
        ? '0'
        : props.theme.spacing.large};
  `}

  ${props =>
    customMedia.greaterThan('xxlarge') &&
    props.availableRatio &&
    `
    max-width: ${props.theme.layout.maxWidth};
    max-height: ${`calc((${props.theme.layout.ratio[1]} * ${props.theme.layout.maxWidth}) / ${props.theme.layout.ratio[0]})`};
  `}
`;

export const ButtonClose = styled(Button)`
  position: absolute;
  z-index: 5;
  top: ${props => props.theme.spacing.small};
  right: ${props => props.theme.spacing.default};
  color: ${props => props.theme.color.wfBlack};

  ${media.medium`
    top: ${props => props.theme.spacing.medium};
    right: ${props => props.theme.spacing.large};
  `}
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-top: 1rem;
`;
